module.exports = __webpack_public_path__ + "img/i02.341eeaff.svg";